module.exports = __webpack_public_path__ + "static/smg-loader-4699ad8d1f2ed283580e2bf9aec752ce.jpg";